import type {
  FormDetail,
  FormSummary,
  FormVersion,
  PublicFormDetail,
  Submission,
  SubmissionDetail,
} from '../types';

function isPublicAudience(form: Pick<FormDetail, 'audienceType'>): boolean {
  return form.audienceType === 'Public';
}

export const mockForms: FormDetail[] = [
  {
    id: '9001',
    title: 'Solicitud de tarea — Proyecto 1',
    description:
      'Completa este formulario para crear una nueva tarea en Tareas Marketing. El equipo la revisará y le dará seguimiento.',
    projectId: '5001',
    status: 'Shared',
    audienceType: 'Public',
    expiresAt: null,
    emailRequired: true,
    currentVersion: 1,
    fields: [
      {
        id: '0',
        fieldType: 'Text',
        label: 'Nombre de la tarea',
        required: true,
        order: 0,
        options: null,
        validation: null,
      },
      {
        id: '1',
        fieldType: 'TextArea',
        label: 'Descripción',
        required: false,
        order: 1,
        options: null,
        validation: null,
      },
      {
        id: '2',
        fieldType: 'Select',
        label: 'Prioridad',
        required: true,
        order: 2,
        options: '["Baja","Media","Alta","Urgente"]',
        validation: null,
      },
      {
        id: '3',
        fieldType: 'Date',
        label: 'Fecha límite',
        required: false,
        order: 3,
        options: null,
        validation: null,
      },
      {
        id: '4',
        fieldType: 'Email',
        label: 'Correo de contacto',
        required: true,
        order: 4,
        options: null,
        validation: null,
      },
      {
        id: '5',
        fieldType: 'Time',
        label: 'Hora preferida de seguimiento',
        required: false,
        order: 5,
        options: null,
        validation: null,
      },
    ],
    createdAt: '2026-06-30T12:00:00Z',
    updatedAt: '2026-07-04T09:00:00Z',
  },
  {
    id: '9002',
    title: 'Brief creativo — Proyecto 1',
    description: 'Reúne los datos que el equipo de diseño necesita antes de empezar una pieza.',
    projectId: '5001',
    status: 'Shared',
    audienceType: 'Private',
    expiresAt: null,
    emailRequired: false,
    currentVersion: 1,
    fields: [
      {
        id: '0',
        fieldType: 'Text',
        label: 'Nombre del proyecto',
        required: true,
        order: 0,
        options: null,
        validation: null,
      },
      {
        id: '1',
        fieldType: 'Text',
        label: 'Objetivo',
        required: true,
        order: 1,
        options: null,
        validation: null,
      },
      {
        id: '2',
        fieldType: 'TextArea',
        label: 'Público objetivo',
        required: false,
        order: 2,
        options: null,
        validation: null,
      },
      {
        id: '3',
        fieldType: 'Date',
        label: 'Fecha de entrega',
        required: true,
        order: 3,
        options: null,
        validation: null,
      },
    ],
    createdAt: '2026-06-20T10:00:00Z',
    updatedAt: '2026-06-25T08:00:00Z',
  },
  {
    id: '9003',
    title: 'Encuesta de satisfacción Q1',
    description: 'Ayúdanos a mejorar el servicio interno del equipo.',
    projectId: null,
    status: 'Shared',
    audienceType: 'Public',
    expiresAt: null,
    emailRequired: false,
    currentVersion: 2,
    fields: [
      {
        id: '0',
        fieldType: 'Select',
        label: 'Prioridad',
        required: true,
        order: 0,
        options: '["Baja","Media","Alta","Urgente"]',
        validation: null,
      },
      {
        id: '1',
        fieldType: 'Text',
        label: 'Nombre de la tarea',
        required: true,
        order: 1,
        options: null,
        validation: null,
      },
      {
        id: '2',
        fieldType: 'TextArea',
        label: 'Descripción',
        required: false,
        order: 2,
        options: null,
        validation: null,
      },
      {
        id: '3',
        fieldType: 'Email',
        label: 'Correo de contacto',
        required: true,
        order: 3,
        options: null,
        validation: null,
      },
      {
        id: '4',
        fieldType: 'LinearScale',
        label: '¿Qué tan satisfecho estás con tu ambiente laboral?',
        required: true,
        order: 4,
        options: '{"min":1,"max":5,"minLabel":"Nada satisfecho","maxLabel":"Muy satisfecho"}',
        validation: null,
      },
      {
        id: '5',
        fieldType: 'Grid',
        label: 'Evalúa los siguientes aspectos',
        required: false,
        order: 5,
        options:
          '{"rows":["Comunicación","Liderazgo","Crecimiento"],"columns":["Malo","Regular","Bueno","Excelente"]}',
        validation: null,
      },
    ],
    createdAt: '2026-03-01T09:00:00Z',
    updatedAt: '2026-07-05T16:00:00Z',
  },
  {
    id: '9004',
    title: 'Solicitud de permiso',
    description: 'Solicita un permiso o día libre al equipo de RRHH.',
    projectId: null,
    status: 'Shared',
    audienceType: 'Private',
    expiresAt: null,
    emailRequired: true,
    currentVersion: 1,
    fields: [
      {
        id: '0',
        fieldType: 'Select',
        label: 'Tipo de permiso',
        required: true,
        order: 0,
        options: '["Vacaciones","Enfermedad","Personal"]',
        validation: null,
      },
      {
        id: '1',
        fieldType: 'Date',
        label: 'Fecha de inicio',
        required: true,
        order: 1,
        options: null,
        validation: null,
      },
      {
        id: '2',
        fieldType: 'Date',
        label: 'Fecha de fin',
        required: true,
        order: 2,
        options: null,
        validation: null,
      },
      {
        id: '3',
        fieldType: 'TextArea',
        label: 'Motivo',
        required: false,
        order: 3,
        options: null,
        validation: null,
      },
    ],
    createdAt: '2026-06-01T09:00:00Z',
    updatedAt: '2026-06-29T09:00:00Z',
  },
  {
    id: '9005',
    title: 'Reporte de incidente — Proyecto 2',
    description: 'Reporta un incidente técnico detectado en producción.',
    projectId: '5002',
    status: 'Closed',
    audienceType: 'Public',
    expiresAt: null,
    emailRequired: true,
    currentVersion: 1,
    fields: [
      {
        id: '0',
        fieldType: 'Text',
        label: 'Título del incidente',
        required: true,
        order: 0,
        options: null,
        validation: null,
      },
      {
        id: '1',
        fieldType: 'Select',
        label: 'Severidad',
        required: true,
        order: 1,
        options: '["Baja","Media","Alta","Crítica"]',
        validation: null,
      },
      {
        id: '2',
        fieldType: 'TextArea',
        label: 'Descripción técnica',
        required: true,
        order: 2,
        options: null,
        validation: null,
      },
      {
        id: '3',
        fieldType: 'Email',
        label: 'Correo de contacto',
        required: true,
        order: 3,
        options: null,
        validation: null,
      },
    ],
    createdAt: '2026-05-01T09:00:00Z',
    updatedAt: '2026-06-05T09:00:00Z',
  },
  {
    id: '9006',
    title: 'Formulario en construcción',
    description: null,
    projectId: '5001',
    status: 'Draft',
    audienceType: 'Private',
    expiresAt: null,
    emailRequired: false,
    currentVersion: 0,
    fields: [
      {
        id: null,
        fieldType: 'Text',
        label: 'Nombre',
        required: true,
        order: 0,
        options: null,
        validation: null,
      },
    ],
    createdAt: '2026-07-05T09:00:00Z',
    updatedAt: '2026-07-05T09:00:00Z',
  },
];

export const mockFormVersions: Record<string, FormVersion[]> = {
  '9003': [
    {
      id: '1',
      versionNumber: 1,
      fieldDefinitions: JSON.stringify(mockForms.find((f) => f.id === '9003')?.fields.slice(0, 3)),
      publishedAt: '2026-03-01T09:00:00Z',
      publishedBy: '4001',
    },
    {
      id: '2',
      versionNumber: 2,
      fieldDefinitions: JSON.stringify(mockForms.find((f) => f.id === '9003')?.fields),
      publishedAt: '2026-06-15T09:00:00Z',
      publishedBy: '4001',
    },
  ],
};

const SUBMITTERS = [
  { id: '4101', email: 'sara.alejandra@innovaforce.com', name: 'Sara Alejandra' },
  { id: '4102', email: 'miguel.alejandro@innovaforce.com', name: 'Miguel Alejandro' },
  { id: '4103', email: 'monica.esquivel@innovaforce.com', name: 'Mónica Esquivel' },
  { id: '4104', email: 'guillermo.sandoval@innovaforce.com', name: 'Guillermo Sandoval' },
];

function buildSubmissionValues(formId: string, index: number): SubmissionDetail['values'] {
  const form = mockForms.find((f) => f.id === formId);
  if (!form) return [];
  return form.fields
    .filter((f) => f.id !== null)
    .map((field, fieldIndex) => {
      if (field.fieldType === 'Select' && field.options) {
        const options: string[] = JSON.parse(field.options);
        return { fieldId: field.id as string, value: options[index % options.length] };
      }
      if (field.fieldType === 'Email')
        return { fieldId: field.id as string, value: SUBMITTERS[index % SUBMITTERS.length].email };
      if (field.fieldType === 'Date') return { fieldId: field.id as string, value: '2026-03-15' };
      if (field.fieldType === 'Time') return { fieldId: field.id as string, value: '14:30' };
      if (field.fieldType === 'LinearScale')
        return { fieldId: field.id as string, value: String((index % 5) + 1) };
      if (fieldIndex === 0)
        return { fieldId: field.id as string, value: `Respuesta de ejemplo ${index + 1}` };
      return { fieldId: field.id as string, value: '' };
    })
    .filter((v) => v.value !== '' || Math.random() > 0.3);
}

export const mockSubmissions: SubmissionDetail[] = mockForms.flatMap((form) =>
  Array.from({ length: form.id === '9003' ? 24 : form.id === '9001' ? 6 : 3 }, (_, i) => {
    const submitter = SUBMITTERS[i % SUBMITTERS.length];
    const isAnonymous = isPublicAudience(form) && i % 5 === 0;
    return {
      id: `${form.id}${String(i).padStart(3, '0')}`,
      formId: form.id,
      formVersionId: String(form.currentVersion || 1),
      submittedById: isAnonymous ? null : submitter.id,
      submittedByEmail: isAnonymous ? null : submitter.email,
      isAnonymous,
      taskId: form.id === '9001' && i === 0 ? '7001' : null,
      values: buildSubmissionValues(form.id, i),
      createdAt: `2026-0${(i % 4) + 3}-${String((i % 27) + 1).padStart(2, '0')}T10:${String(i % 60).padStart(2, '0')}:00Z`,
    } satisfies SubmissionDetail;
  }),
);

export function toSummary(form: FormDetail): FormSummary {
  return {
    id: form.id,
    title: form.title,
    projectId: form.projectId,
    status: form.status,
    audienceType: form.audienceType,
    expiresAt: form.expiresAt,
    fieldCount: form.fields.length,
    submissionCount: mockSubmissions.filter((s) => s.formId === form.id).length,
    createdAt: form.createdAt,
    updatedAt: form.updatedAt,
  };
}

export function toPublicDetail(form: FormDetail): PublicFormDetail {
  return {
    id: form.id,
    title: form.title,
    description: form.description,
    status: form.status,
    audienceType: form.audienceType,
    expiresAt: form.expiresAt,
    emailRequired: form.emailRequired,
    fields: form.fields,
  };
}

export function toSubmission(detail: SubmissionDetail): Submission {
  const { values: _values, formVersionId: _formVersionId, ...rest } = detail;
  return rest;
}
